var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"website-header",style:({
    '--app-header-nav-height': _vm.app_nav_height,
    '--app-header-menu-item-width': _vm.app_menu_item_width,
    '--app-header-menu-item-height': _vm.app_menu_item_height,
  })},[_c('div',{staticClass:"website-header-main"},[_c('WebsiteLogo'),_c('WNav'),_c('WFRight')],1),_c('WHMoreMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }